import React, { ReactNode } from 'react';

interface BulkActionButtonProps {
  /**
   * The icon to display in the button
   */
  icon: ReactNode;

  /**
   * The label text for the button
   */
  label: string;

  /**
   * Function to call when the button is clicked
   */
  onClick: () => void;

  /**
   * Optional class name to add to the button
   */
  className?: string;
}

/**
 * A button component for use in the FloatingBulkActionsContainer.
 * Displays an icon above a text label.
 */
export const BulkActionButton: React.FC<BulkActionButtonProps> = ({
  icon,
  label,
  onClick,
  className = '',
}) => {
  return (
    <button
      className={`dark:bg-base-100 dark:hover:bg-base-200 flex h-16 w-24 flex-col items-center justify-center rounded-lg bg-white p-3 hover:bg-gray-50 focus:ring-2 focus:ring-gray-300 focus:outline-none ${className}`}
      onClick={onClick}
      aria-label={label}
      title={label}>
      <div className="mb-1">{icon}</div>
      <span className="text-xs font-medium">{label}</span>
    </button>
  );
};
